import apiClient from "../config/apiClient";


export const fetchLabRequestsAlt = async (id) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    return await apiClient.get(`/public/portal?url=requests/${id}/request/portal/labs`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  };
  
